module.exports = __webpack_public_path__ + "static/media/item-17.65a6b123.png";